import React from 'react';
import { useDispatch } from 'react-redux';
import { updateUserProfile } from '@store/actions/UserProfileActionCreators';
import {
	PracticeInterface,
	UserDetailsApiInterface,
	UserDetailsOffice,
} from '@interfaces/UserPrefInterface';
import { useHistory } from 'react-router-dom';
import { ROUTE_CONSTANTS } from '@utilities/RouteConstants';
import { StorageKey } from '@utilities/authConstants';
import { apiStart } from '@store/middlewares/api/ApiActionCreators';
import { REQUEST_FORM_DUMMY_LOADER } from '@store/actions/types';

export const useChangePractice = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const practiceRef = React.useRef<Partial<PracticeInterface> | null>(null);

	const setPractice = React.useCallback((practiceId: Partial<PracticeInterface>) => {
		const onChangePracticeSuccess = () => {
			history.push(ROUTE_CONSTANTS.HOME, {
				shouldReloadApp: true,
			});
			if (practiceRef.current !== practiceId) {
				window.sessionStorage.removeItem(StorageKey.BLOCK_SURGEONS);
				practiceRef.current = practiceId;
			}
		};

		const payload: Partial<UserDetailsOffice> = {
			primaryPractice: practiceId as PracticeInterface,
		};

		dispatch(updateUserProfile<UserDetailsOffice, UserDetailsApiInterface>(payload, onChangePracticeSuccess));
		dispatch(apiStart(REQUEST_FORM_DUMMY_LOADER, REQUEST_FORM_DUMMY_LOADER, REQUEST_FORM_DUMMY_LOADER, false));
	}, [dispatch, history]);

	return { setPractice };
};
